import { forwardRef, memo, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
// Skillmore UI Components
import { fontWeightMedium } from '@empathco/ui-components/src/styles/themeOptions';
import CheckboxButton from '@empathco/ui-components/src/elements/CheckboxButton';

type LevelConfirmCheckboxProps = {
  readonly label: string;
  readonly checked?: boolean;
  readonly onChange?: (checked: boolean) => void;
  readonly disabled?: boolean | null;
}

const LevelConfirmCheckbox = forwardRef<HTMLLabelElement, LevelConfirmCheckboxProps>(({
  label,
  checked,
  onChange,
  disabled
}, ref) => {
  const inactive = Boolean(disabled);

  const handleChange = useCallback((chk: boolean) => {
    onChange?.(chk);
  }, [onChange]);

  const labelSx = useMemo(() => ({
    pl: 1.25,
    color: inactive ? 'action.disabled' : 'secondary.text',
    fontWeight: fontWeightMedium
  }), [inactive]);

  return (
    <FormControlLabel
        ref={ref}
        control={(
          <CheckboxButton
              label={label}
              checked={Boolean(checked)}
              onChange={handleChange}
              disabled={inactive}
          />
        )}
        label={(
          <Box sx={labelSx}>
            <FormattedMessage id={label} defaultMessage={label}/>
          </Box>
        )}
    />
  );
});

LevelConfirmCheckbox.displayName = 'LevelConfirmCheckbox';

export default memo(LevelConfirmCheckbox);
